"use strict";

import dispatcher from "./../dispatcher";
import sessionStore from "./session";
import {Singleton} from "vwa/flux";

const vehicleFilterExpressionStore = new Singleton();
export default vehicleFilterExpressionStore;

window.vehicleFilterExpressionStore = vehicleFilterExpressionStore;

const defaultExpression = {
	text: "",
	movement: null
};

vehicleFilterExpressionStore.set(defaultExpression);

dispatcher.on('filterVehicles', expression => {
	vehicleFilterExpressionStore.set(expression ? {
		text: expression.text === undefined ? vehicleFilterExpressionStore.get().text : expression.text,
		movement: expression.movement === undefined ? vehicleFilterExpressionStore.get().movement : expression.movement
	} : defaultExpression);
});

sessionStore.on('change', session =>
	vehicleFilterExpressionStore.set(defaultExpression)
);


// WEBPACK FOOTER //
// ./src/store/vehicleFilterExpression.js